/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  CheckUsageDto,
  InspectionItemDto,
  QuotationDto,
  QuotationsGetResponseDto,
  QuoteStructureRequestItemDto,
  SalesFolderEdocSigningRequestDto,
  SiteDetailsBase,
  SiteDetailsDto,
  SiteListDto,
  SiteListItemDto,
} from '@gh/builder-shared-data';
import { createArrayHelper } from '@gh/common-shared';
import { ID, WithEntityState } from '@gh/common-shared-data';
import { isEmpty, isNil, map, omit, uniqueId } from 'lodash';

export type RfqSite = SiteDetailsBase & {
  inspections: InspectionItem[];
};
export type InspectionItem = WithEntityState<InspectionItemDto & { id: ID }>;
export type RfqSiteListItem = SiteListItemDto;
export type RfqSiteList = SiteListDto;
export type RfqSiteCheckUsage = CheckUsageDto;
export type RfqQuotation = QuotationDto;
export type RfqQuotationsGetResponse = QuotationsGetResponseDto;
export type QuoteStructureRequestItem = QuoteStructureRequestItemDto;
export type SalesFolderEDocSigningRequest = SalesFolderEdocSigningRequestDto;

export function checkUsageFromDto(dto: CheckUsageDto): CheckUsageDto {
  return {
// @ts-expect-error Legacy typing suppression
    deleted: isNil(dto.deleted) ? true : dto.deleted,
    ...dto,
  };
}

export const rfqInspectionFromDto = (inspection: InspectionItemDto): InspectionItem =>
  ({ ...inspection, id: uniqueId('inspection:') });
export const rfqInspectionToDto = (dto: InspectionItem): InspectionItemDto =>
  <InspectionItemDto>omit(dto, 'id', 'entityState');
export const rfqSiteFromDto = (dto: SiteDetailsDto): RfqSite => ({
  ...<RfqSite>omit(dto, 'inspections'),
  inspections: map(dto.inspections, rfqInspectionFromDto),
});

export const rfqSiteToDto = (model: RfqSite): SiteDetailsDto => ({
  ...<SiteDetailsDto>omit(model, 'inspections'),
  inspections: map(model.inspections, rfqInspectionToDto),
});

export const getInspectionItemId = (item: InspectionItem) => item.id;
export const hasInspectionAvailableValues = (item: InspectionItem) => !isEmpty(item.availableValues);

export const inspectionArr = createArrayHelper(getInspectionItemId);
